<template>
    <Card class="profile-basic-wrap" :bordered="false">
        <el-scrollbar v-if="scrollbar" class="profile-basic-scrollbar">
            <slot/>
        </el-scrollbar>
        <template v-else><slot/></template>
    </Card>
</template>

<script>
export default {
    name: 'profile-basic',
    props: {
        scrollbar: {
            type: Boolean,
            default: true
        }
    },
    methods: {
    },
}
</script>

<style lang="less">
.profile-basic-wrap {
    height: 100%;
    .ivu-card-body {
        height: 100%;
    }
}
.profile-basic-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
        overflow-x: hidden!important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/profile-basic.vue